import { LoginPayload, AuthResponse, UsuarioInfo, RegisterPayload, EmpresaRegistroPayload } from '../tipos/vacaciones';
import { API_ENDPOINTS } from '../config/apiConfig';

async function handleResponse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const body = await response.text();
    let mensaje = 'Error en la solicitud';
    try {
      const json = JSON.parse(body);
      mensaje = json.message || json.error || json.title || mensaje;
    } catch {
      if (body) mensaje = body;
    }
    throw new Error(mensaje);
  }
  return response.json();
}

export async function login(payload: LoginPayload): Promise<AuthResponse> {
  const response = await fetch(API_ENDPOINTS.login, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return handleResponse<AuthResponse>(response);
}

export async function register(payload: RegisterPayload, token: string): Promise<AuthResponse> {
  const response = await fetch(API_ENDPOINTS.register, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  return handleResponse<AuthResponse>(response);
}

export async function registrarEmpresa(payload: EmpresaRegistroPayload): Promise<AuthResponse> {
  const response = await fetch(API_ENDPOINTS.registrarEmpresa, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return handleResponse<AuthResponse>(response);
}

export async function refreshToken(token: string, refreshTk: string): Promise<AuthResponse> {
  const response = await fetch(API_ENDPOINTS.refreshToken, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, refreshToken: refreshTk }),
  });
  return handleResponse<AuthResponse>(response);
}

export async function getMe(token: string): Promise<UsuarioInfo> {
  const response = await fetch(API_ENDPOINTS.me, {
    method: 'GET',
    headers: { 'Authorization': `Bearer ${token}` },
  });
  return handleResponse<UsuarioInfo>(response);
}

export async function revokeToken(refreshTk: string, token: string): Promise<void> {
  await fetch(API_ENDPOINTS.revokeToken, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({ token: refreshTk }),
  });
}
